import React from 'react';

// impoert ui
import {
  CommandBar,
  CommandBarButton,
  PrimaryButton,
  SearchBox,
  SelectionMode,
  ShimmeredDetailsList,
  Stack,
  Text,
} from '@fluentui/react';
import FaqsService from '../../../../services/faqs';
import { ProviderStore } from '../../../../context';
import { IFaqResourceShort } from '../../../../props/faqs';
import UpdateFaqsPanel from './surfaces/panelUpdateExpenses';
import AddFaqPanel from './surfaces/panelAddExpenses';

// import component

interface IFaqsPageProps {
  context: ProviderStore;
}

interface IFaqsPageState {
  faqs: IFaqResourceShort[];
  loaded: boolean;
  addFaqsDialog?: JSX.Element;
  updateFaqsDialog?: JSX.Element;
}

export default class FaqsPage extends React.Component<IFaqsPageProps, IFaqsPageState> {
  constructor(props: IFaqsPageProps) {
    super(props);

    this.state = {
      faqs: [],
      loaded: false,
    };
  }

  componentDidMount() {
    this.getFaqs();
  }

  private getFaqs = async () => {
    try {
      const faqs = await FaqsService.retrieve();
      this.setState({ faqs, loaded: true });
    } catch (error) {}
  };

  public render() {
    const { faqs, loaded, addFaqsDialog, updateFaqsDialog } = this.state;
    return (
      <Stack tokens={{ childrenGap: 15 }}>
        {addFaqsDialog}
        {updateFaqsDialog}
        <Text variant={'xLarge'}>Faqs</Text>
        <CommandBar items={this.getItems()} />
        <ShimmeredDetailsList
          selectionMode={SelectionMode.none}
          items={faqs}
          enableShimmer={!loaded}
          columns={[
            {
              key: 'no',
              name: 'No',
              maxWidth: 20,
              minWidth: 20,
              isMultiline: true,
              onRender: (item: IFaqResourceShort, ix) => (
                <Stack horizontal styles={{ root: { width: '100%' } }} verticalAlign='center'>
                  <Text>{(ix || 0) + 1}</Text>
                </Stack>
              ),
            },
            {
              key: 'question',
              name: 'Pertanyaan',
              maxWidth: 200,
              minWidth: 200,
              isMultiline: true,
              onRender: (item: IFaqResourceShort) => (
                <Stack
                  horizontal
                  styles={{ root: { width: '100%' } }}
                  verticalAlign='center'
                  horizontalAlign='space-between'
                >
                  <Text>{item.question}</Text>
                  <CommandBarButton
                    menuProps={{
                      items: [
                        {
                          key: 'update',
                          text: 'Update',
                          iconProps: { iconName: 'SingleColumnEdit' },
                          onClick: () =>
                            this.setState({
                              updateFaqsDialog: (
                                <UpdateFaqsPanel
                                  closePanel={(r) => {
                                    if (r) {
                                      this.getFaqs();
                                    }
                                    this.setState({ updateFaqsDialog: undefined });
                                  }}
                                  faqs={item}
                                />
                              ),
                            }),
                        },
                        {
                          key: 'delete',
                          text: 'Delete',
                          iconProps: { iconName: 'Delete' },
                          onClick: () => {
                            this.deleteFaqs(item);
                          },
                        },
                      ],
                    }}
                  />
                </Stack>
              ),
            },
            {
              key: 'answer',
              name: 'Jawaban',
              maxWidth: 200,
              minWidth: 200,
              isMultiline: true,
              onRender: (item: IFaqResourceShort) => (
                <Stack
                  horizontal
                  styles={{ root: { width: '100%' } }}
                  verticalAlign='center'
                  horizontalAlign='space-between'
                >
                  <Text>{item.answer}</Text>
                </Stack>
              ),
            },
          ]}
        />
      </Stack>
    );
  }

  private getItems = () => {
    const { loaded } = this.state;
    return [
      {
        key: 'search',
        text: 'Search',
        onRender: () => {
          return <SearchBox disabled={!loaded} />;
        },
      },
      {
        key: 'add',
        text: 'Add',
        onRender: () => {
          return (
            <PrimaryButton
              disabled={!loaded}
              iconProps={{ iconName: 'Add' }}
              text='Add Faqs'
              styles={{ root: { marginLeft: 10 } }}
              onClick={() =>
                this.setState({
                  addFaqsDialog: (
                    <AddFaqPanel
                      closePanel={(r?: boolean) => {
                        if (r) {
                          this.getFaqs();
                        }
                        this.setState({ addFaqsDialog: undefined });
                      }}
                    />
                  ),
                })
              }
            />
          );
        },
      },
    ];
  };

  private deleteFaqs = async (item: IFaqResourceShort) => {
    if (window.confirm('Delete Faqs')) {
      try {
        await FaqsService.delete(item.id);
        this.getFaqs();
      } catch (error) {}
    }
  };
}
